export const TooltipIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="tooltip-icon_bgCarrier" strokeWidth="0" />
    <g
      id="tooltip-icon_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="tooltip-icon_iconCarrier">
      <path
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M9 10h14M9 14h14M9 18h6m2.4 8.8 2.4-2.4A2.8 2.8 0 0 1 21.76 24H26a2.8 2.8 0 0 0 2.8-2.8V8a2.8 2.8 0 0 0-2.8-2.8H6A2.8 2.8 0 0 0 3.2 8v14A2.8 2.8 0 0 0 6 24.8h4.44a2.8 2.8 0 0 1 1.98.82l2.4 2.4a1.4 1.4 0 0 0 1.98 0z"
      />
    </g>
  </svg>
);
